import styled from "styled-components/macro"

export const ContainerElement = styled.div``

export const ArrowContainerElement = styled.div`
  position: relative;
  cursor: pointer;
  margin-top: 25px;
  max-width: 426px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TitleContainerElement = styled.div``
